import React from 'react';

import { Button } from '@mui/material';

import { EmptyContent } from 'src/components/empty-content';

interface TxEmptyProps {
  title?: string;
  error?: string;
  /** Quando presente, rende a ação 'Limpar filtros' no ramo de erro. */
  onClearFilters?: () => void;
}

/**
 * Ramo de erro via `EmptyContent` (description + action), não Box com texto em
 * error.main puro.
 *
 * `filled`: usar quando o vazio ocupa um cartão próprio — é a moldura tracejada
 * do catálogo do canvas. No grid (overlay) NÃO usar `filled`: o overlay já vive
 * dentro do Paper da grade.
 */
export function TxEmpty({ title, error, onClearFilters }: TxEmptyProps) {
  if (error) {
    return (
      <EmptyContent
        title={title}
        description={error}
        action={
          onClearFilters ? (
            <Button variant="outlined" size="small" onClick={onClearFilters}>
              Limpar filtros
            </Button>
          ) : undefined
        }
      />
    );
  }
  return <EmptyContent title={title} />;
}
